<template>
    <v-sheet class="mx-auto pt-4" width="300" color="#212121">
        <v-form @submit.prevent>
            <!-- <v-text-field v-model="goToPointStrategy" label="Status Go To Point" disabled></v-text-field> -->
            <v-text-field v-model="coordinates" label="Coordenadas" disabled></v-text-field>
            <v-text-field type="number" v-model.number="altitude" :rules="rules" label="Altura"></v-text-field>
            <v-text-field v-if="goToPointStrategy == 1" type="number" v-model.number="altitudeRTH" :rules="rulesRTH" label="Altura de RTH"></v-text-field>
            <v-text-field v-if="goToPointStrategy == 1" type="number" v-model.number="altitudeSecureTakeoff" :rules="rulesSecureTakeOff" label="Altura de despegue"></v-text-field>
            
            <!-- <v-text-field type="number" v-model.number="altitudeSecureTakeoff" :rules="rules" label="Altura segura de despegue"></v-text-field> -->
            <!-- <v-text-field v-model="requestAltitude" label="Request Altitude" disabled></v-text-field> -->
            <v-btn class="mt-2" @click="goToPoint" type="submit" block>Ir al punto</v-btn>
        </v-form>
    </v-sheet>

</template>

<script setup>
/* eslint-disable */

import { CURRENT_CONFIG, HMIN_CONFIG, HMAX_CONFIG } from '../../../../api/http/config.ts';
import { onMounted } from 'vue'
import { defineProps, computed, ref } from 'vue'

import { sendRegistryEvent } from '@/services/backendOpService.js';

const props = defineProps({
    event: Object,
})
import { storeToRefs } from "pinia";

onMounted(() => {
    console.warn(props.event)
    const eventString = JSON.stringify(props.event);
    console.warn(eventString)
})
import useStore from "@/store";
const store = useStore();
const droneSn = store.child_device_sn;
const dockSn = store.device_sn;
import { getDroneTelemetry } from "../../utils/droneTelemetryUtils.js";
import { getDockTelemetry } from "../../utils/dockTelemetryUtils.js";

const { telemetry, droneConnected } = storeToRefs(store);

const telemetryData = computed(() => {
    return telemetry.value
})
/*
const altitude = ref(CURRENT_CONFIG.hmin)
const altitudeRTH = ref(CURRENT_CONFIG.hmin)
const altitudeSecureTakeoff = ref(CURRENT_CONFIG.hmin)
*/
const altitude = ref(HMIN_CONFIG.value)
const altitudeRTH = ref(HMIN_CONFIG.value)
const altitudeSecureTakeoff = ref(HMIN_CONFIG.value)

//const hmin = ref(1500)
//const hmax = ref(600)

/*

*/


const rulesRTH = [
    value => {
        if (value) return true
        return "Ingrese un valor valido"
    },
    value => {
        const number = parseFloat(value);
        //return (number >= CURRENT_CONFIG.hmin && number <= CURRENT_CONFIG.hmax) || 'El valor debe estar entre ' + CURRENT_CONFIG.hmin +' y ' + CURRENT_CONFIG.hmax;
        return (number >= HMIN_CONFIG.value && number <= HMAX_CONFIG.value) || 'El valor debe estar entre ' + HMIN_CONFIG.value +' y ' + HMAX_CONFIG.value;
    }
]

const rulesSecureTakeOff = [
    value => {
        if (value) return true
        return "Ingrese un valor valido"
    },
    value => {
        const number = parseFloat(value);
        return (number >= HMIN_CONFIG.value && number <= HMAX_CONFIG.value) || 'El valor debe estar entre ' + HMIN_CONFIG.value + ' y ' + HMAX_CONFIG.value;
    }
]

//const altitudeSecureTakeoff = ref(100)
const rules = [
    value => {
        if (value) return true
        return "Ingrese un valor valido"
    },
    value => {
        const number = parseFloat(value);
        return (number >= HMIN_CONFIG.value && number <= HMAX_CONFIG.value) || 'El valor debe estar entre ' + HMIN_CONFIG.value + ' y ' + HMAX_CONFIG.value;
    }
]

const coordinates = computed(() => {
    return Number(props.event.latitude).toFixed(6) + ", " + Number(props.event.longitude).toFixed(6);
})

const exist = (data) => {
    return data !== undefined && data !== null;
};


const dockStatus = computed(() => {
    try {
        return telemetry.value[dockSn]["osd_telemetry"]["data"]["mode_code"]
    } catch {
        return -1
    }
});

const dockASL = computed(() => {
    try {
        return Math.floor(telemetry.value[dockSn]["osd_telemetry"]["data"]["height"])
    } catch {
        return -1
    }
})

const droneStatus = computed(() => {
    try {
        return telemetry.value[droneSn]["osd_telemetry"]["data"]["mode_code"]
    } catch {
        return -1
    }
});

const requestAltitude = computed(() => {
    return dockASL.value + altitude.value
})

const getTakeoffToPointBody = () => {
    return {
        target_height: requestAltitude.value,
        target_latitude: Number(props.event.latitude).toFixed(12),
        target_longitude: Number(props.event.longitude).toFixed(12),
        security_takeoff_height: altitudeSecureTakeoff.value,
        max_speed: 15,
        rc_lost_action: 2,
        rth_altitude: HMIN_CONFIG.value,
        exit_wayline_when_rc_lost: 1,
        commander_mode_lost_action: 1,
        commander_flight_mode: 1,
        commander_flight_height: HMIN_CONFIG.value, // Parametro de seguridad de 150m
        rth_mode: 1,
    }
}

const getFlyToPoint = () => {
    return {
        max_speed: 15,
        points: [{
            latitude: Number(props.event.latitude).toFixed(12),
            longitude: Number(props.event.longitude).toFixed(12),
            height: requestAltitude.value,
        }],
    }
}

// eslint-disable-next-line
const goToPointStrategy = computed(() => {
    if (dockStatus.value == 0) {
        return 1
    } else if (dockStatus.value == 4 && droneStatus.value == 3) {
        return 2
    } else {
        return -1
    }
})


import { postTakeoffToPoint, postFlyToPoint } from '../../../../api/drone-control/drone.ts';

const goToPoint = async () => {
    if (dockStatus.value == 0) {
        const result = await postTakeoffToPoint(dockSn, getTakeoffToPointBody())
        await sendRegistryEvent(Number(props.event.latitude).toFixed(12), Number(props.event.longitude).toFixed(12), requestAltitude.value, JSON.stringify(props.event))
        console.warn(result)
    } else if (dockStatus.value == 4 && droneStatus.value == 3) {
        const result = await postFlyToPoint(dockSn, getFlyToPoint())
        console.warn(result)
        await sendRegistryEvent(Number(props.event.latitude).toFixed(12), Number(props.event.longitude).toFixed(12), requestAltitude.value, JSON.stringify(props.event))
    } else {
        console.log("Can't go to point")
    }
}

</script>

<style></style>
